import { Module } from 'vuex-smart-module';
import PartnerProductsActions from './actions';
import PartnerProductsGetters from './getters';
import PartnerProductsMutations from './mutations';
import PartnerProductsState from './state';

export default new Module({
  state: PartnerProductsState,
  mutations: PartnerProductsMutations,
  actions: PartnerProductsActions,
  getters: PartnerProductsGetters,
});
